import React from 'react';
import { Radio as Radio$1, RadioGroup as RadioGroup$1 } from '@chakra-ui/react';

/**
 * A styled Radio Button with label.
 *
 * All `<Radio>` components must live within a `<RadioGroup>`
 *
 * For props, see [Chakra UI's `<Radio>`
 * docs](https://v1.chakra-ui.com/docs/form/radio)
 */
var Radio = function Radio(props) {
  return /*#__PURE__*/React.createElement(Radio$1, props);
};

/**
 * All `<Radio>` components must live within a `<RadioGroup>`
 *
 * For props, see [Chakra UI's `<RadioGroup>`
 * docs](https://v1.chakra-ui.com/docs/form/radio)
 */
var RadioGroup = RadioGroup$1;

export { Radio, RadioGroup };
